export default __webpack_public_path__ + "static/media/livraria_a.a3a618ac.jpg";